module.exports = __webpack_public_path__ + "static/media/3.da6f02a2.JPG";